import { AlertTriangle, XCircle, HardDrive } from "lucide-react";
import { useStorageStatus } from "../hooks/useStorageStatus";
import { Progress } from "./ui/progress";

export default function StorageWarningBanner() {
  const { data: status, isLoading } = useStorageStatus();

  // Don't show anything while loading or if no limit is configured
  if (isLoading || !status || status.limit_bytes === null) {
    return null;
  }

  // Don't show if below warning threshold
  if (!status.is_warning && !status.is_critical) {
    return null;
  }

  const isCritical = status.is_critical;
  const percentage = Math.round(status.used_percentage);

  return (
    <div
      className={`px-4 py-3 border-b ${
        isCritical
          ? "bg-red-50 border-red-200 text-red-800"
          : "bg-amber-50 border-amber-200 text-amber-800"
      }`}
    >
      <div className="flex items-center gap-3 max-w-7xl mx-auto">
        <div className="flex-shrink-0">
          {isCritical ? (
            <XCircle className="h-5 w-5 text-red-600" />
          ) : (
            <AlertTriangle className="h-5 w-5 text-amber-600" />
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <HardDrive className="h-4 w-4" />
            <span className="font-medium">
              {isCritical ? "Storage Full" : "Storage Almost Full"}
            </span>
            <span className="text-sm opacity-80">
              {status.used_bytes_human} / {status.limit_bytes_human} ({percentage}%)
            </span>
          </div>

          <div className="flex items-center gap-3">
            <Progress
              value={percentage}
              className={`h-2 flex-1 max-w-xs ${
                isCritical ? "[&>div]:bg-red-600" : "[&>div]:bg-amber-600"
              }`}
            />
            <span className="text-sm">
              {isCritical
                ? "Uploads are blocked. Please delete files to continue."
                : "Consider deleting unused files to free up space."}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
